export default __webpack_public_path__ + "static/media/logo-staynfun_1.327c16e3.svg";